var Apidae_Layout = (function(){
    var self = {};
    var grid = $('.grid');

    self.gridScrollBar = undefined;

    self.infiniteScroll = function(){
        loadData = true;
        var href = $('.paginationAjax a').attr('href');
        $('.paginationAjax').remove();

        if(!!href) {
            Apidae_Util.ajaxSend('.spinnerPaginate');
            $.get(href, function (data) {
                var jqObj = jQuery(data);
                var items = $(jqObj.find(".grid .grid__item"));
                var newPaginationAjax = $(jqObj.find(".paginationAjax"));

                $('.pagination').append(newPaginationAjax);

                imagesLoaded(items, function () {
                    grid.append(items);

                    $('html, body').animate({ scrollTop: '+=0' }, 500);
                    Apidae_Util.ajaxComplete('.spinnerPaginate');
                    loadData = false;
                });
            });
        }
    };

    self.loadSlider = function(){
        $('.sliders').bxSlider({
            slideWidth:0,
            minSlides:1,
            maxSlides:1,
            moveSlides:1,
            slideMargin:0,
            mode: 'fade',
            pager: false,
            auto: false,
            adaptiveHeight: true,
            captions: false
        });
    };

    self.init = function(){

        Apidae_Layout.Events.init();
    };

    return self;
})();

Apidae_Layout.Events = (function(){
    var self = {};
    var gridContainer = $('#theGrid');
    //var gridWrap = $('.grid__wrapper');
    //var gridWrapOffsetTop = gridWrap.offset().top;
    var grid = $('.grid');
    var mapContainer = $('#mapContainer');
    var searchByMap = $('.TopBar__searchByMap');
    var layoutModeValue = 'list';

    self.init = function(){

        // change masonry mode
        $('.masonry-mode-button-group').on( 'click', 'button', function() {
            var masonryModeValue = $(this).data('masonry-mode');
            grid.attr('data-masonry-mode', masonryModeValue);
        });

        function gridLayout() {
            Apidae_Map.resize();
            Apidae_Map.setMarkers(true);
        }

        // change layout mode
        $('.layout-mode-button-group').on( 'click', 'button', function() {
            layoutModeValue = $(this).data('layout-mode');
            gridContainer.removeClass().addClass(layoutModeValue);
            setTimeout(gridLayout, 300);

        });

        // change is-checked class on buttons
        $('.button-group').each( function( i, buttonGroup ) {
            var $buttonGroup = $( buttonGroup );
            $buttonGroup.on( 'click', 'button', function() {
                $buttonGroup.find('.is-checked').removeClass('is-checked');
                $(this).addClass('is-checked');
            });
        });


        // infinite scroll
        $(window).scroll(function(){

            if($('.paginationAjax').length){
                var loadData = false;
                var scrollTop = $(window).scrollTop();
                var browserHeight = $(window).height();
                var offset = $('.paginationAjax').offset();

                if(offset!==null && (offset.top - browserHeight - 644 <= scrollTop) && (loadData === false) ){
                    // console.log(offset.top - browserHeight);
                    // console.log(scrollTop);
                    Apidae_Layout.infiniteScroll();
                }
            }
        });

    };

    return self;
})();

$(window).load(function(){
    Apidae_Layout.init();
});